import { Image, ImageWithCaption, ImageWithVideo } from "@sourceful/shared-types";

export interface BasicImage {
  assetRef: string;
  description?: string;
  caption?: string;
  altText?: string;
  youtubeId?: string;
  autoplay?: boolean;
}

type ImageType = Image | ImageWithCaption | ImageWithVideo;

function isVideo(obj: ImageType): obj is ImageWithVideo {
  return !!obj.metadata?.youtubeId;
}

export const sanityImageToBasicImage = (sanityImage: ImageType): BasicImage => {
  const common = {
    assetRef: sanityImage.asset._ref,
    description: sanityImage?.asset?.description,
    altText: sanityImage.asset.altText,
  };

  if (isVideo(sanityImage))
    return {
      ...common,
      youtubeId: sanityImage.metadata.youtubeId,
      autoplay: sanityImage.metadata.autoplay === true,
    };

  return {
    ...common,
    caption: sanityImage?.metadata?.caption,
  };
};
